/* unplugin-vue-components disabled */import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-05d48bbe"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "miniapp"
};
const _hoisted_2 = ["href"];
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const docUrl = ref(process.env.VUE_APP_OFFICIAL_DOC);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("a", {
        href: _unref(docUrl)
      }, "查看接入文档", 8, _hoisted_2)]);
    };
  }
});